module.exports = __webpack_public_path__ + "static/media/29DUNON3.ce475857.jpg";